import { skyFoundationSettings } from '../../../services/configs/configs-service';
import { SITE_NAMES } from '../../../utils/constants';
import { getLabel } from '../../../labels/labelling-service';

import widget from './widget';

const USER_TYPES = {
  PARCO: 'PARCO',
  PROSPECT: 'PROSPECT',
};

const widgetConfig = {
  ...widget,
  elementIds: {
    WPNId: 'autoPushNotificationsInPage',
    newsletterId: 'newsletterInPage',
  },
  loggedKey: 'logged',
  notLoggedKey: 'notLogged',
  blockTypes: {
    hero: 'personalization-hero',
    heading: 'personalization-heading',
    messengerPeople: 'personalization-fb-telegram-bot',
    notifications: 'personalization-notifications',
    panel: 'personalization-panel',
    myTeam: 'personalization-my-team',
    mySport: 'personalization-my-sport',
    myLocalNews: 'personalization-local-news',
    newsletters: 'personalization-newsletter',
    noContent: 'personalization-no-content',
  },
  telegramWidgetId: {
    [SITE_NAMES.SPORT]: {
      collEnvironement: '1397861f0296659cb14.02221203',
      prodEnvironement: '1455862a2fcbea91396.74971251',
    },
  },
  messengerWidgetId: {
    [SITE_NAMES.SPORT]: {
      collEnvironement: '1397761f02674517e65.56725459',
      prodEnvironement: '1455762a2fbf733e217.21191712',
    },
    [SITE_NAMES.NEWS]: {
      collEnvironement: '148796310a9c94727b6.13679222',
      prodEnvironement: '148806310aa27bc8c87.64511118',
    },
  },
  tabsNames: ['contenuti', 'personalizza'],
};

const PREMIUM_PRODUCT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NEVER: 'never',
};

const premiumWidget = {
  products: {
    [SITE_NAMES.SPORT]: {
      [PREMIUM_PRODUCT_STATUS.ACTIVE]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description3'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description1'),
        },
      },
      [PREMIUM_PRODUCT_STATUS.INACTIVE]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description6'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description2'),
        },
      },
      [PREMIUM_PRODUCT_STATUS.NEVER]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description6'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title1'),
          description: getLabel('premium.description2'),
        },
      },
    },
    [SITE_NAMES.NEWS]: {
      [PREMIUM_PRODUCT_STATUS.ACTIVE]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description3'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description1'),
        },
      },
      [PREMIUM_PRODUCT_STATUS.INACTIVE]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description5'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description4'),
        },
      },
      [PREMIUM_PRODUCT_STATUS.NEVER]: {
        [USER_TYPES.PARCO]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description5'),
        },
        [USER_TYPES.PROSPECT]: {
          title: getLabel('premium.title2'),
          description: getLabel('premium.description4'),
        },
      },
    },
  },
};

export default {
  ...widgetConfig,
  premiumWidget,
};
